<div fusePerfectScrollbar fxLayout="column" id="login">

  <div fxLayout="column" fxLayoutAlign="center center" id="login-form-wrapper">
    <div id="login-form" class="login-form--grid login-form--bg-sapiens">

      <app-login-logo></app-login-logo>

      <section class="login__section login__section-form">
        <h2 class="title mat-headline-6">
          {{ "authentication.title" | translate }}
        </h2>
        <app-login-form></app-login-form>
      </section>

      @if (activateAuthenticationByThirdParty) {
        <section class="login__section login__section-register-api">
          <h2 class="title login__section-register-api__title" >
            {{ "login-section-register-api.title" | translate }}
          </h2>
          <div class="login__section-register-api__button-wrapper"
            [class.has-iframe-focused]="isGoogleIframeFocused()">
            <mat-icon svgIcon="google" class="login__section-register-api__button-icon"></mat-icon>
            <span class="login__section-register-api__button-text">{{ "authentication.btn-login-sign-in-google" | translate }}</span>
            <div id="google-signin-button"></div>
          </div>
          <div class="login__section-register-api__button-wrapper">
            <mat-icon svgIcon="apple" class="login__section-register-api__button-icon"></mat-icon>
            <span class="login__section-register-api__button-text">{{ "authentication.btn-login-sign-in-apple" | translate }}</span>
            <div id="appleid-signin"></div>
          </div>
          <div class="login__section-register-api__button-wrapper">
            <mat-icon svgIcon="facebook" class="login__section-register-api__button-icon"></mat-icon>
            <span class="login__section-register-api__button-text">{{ "authentication.btn-login-sign-in-facebook" | translate }}</span>
            <button id="facebook-signin-button" data-e2e="login-sign-in-facebook" (click)="signInWithFacebook()"></button>
          </div>
          <app-register-link></app-register-link>
        </section>
      }

      @if (!isEndOfFreeDemo) {
        <section class="login__section login__section-demo">
          <h2 class="title mat-headline-6">
            {{ "authentication_demo.title" | translate }}
          </h2>
          <img src="assets/{{ assetbrand }}/images/backgrounds/sapiens_Intro_screen.png" alt="sapiens demo" data-e2e="login-open-demo-image" (click)="onOpenDemoClick()" >
          <a
            color="accent"
            mat-raised-button
            data-e2e="login-open-demo-link"
            (click)="onOpenDemoClick()"
            [routerLink]="'/demo'"
            class="login__section login__section-demo__button"
            >
            <mat-icon svgIcon="play-demo" class="login__section-demo__button-icon"></mat-icon>
            {{ 'authentication_demo.link' | translate }}
          </a>
        </section>
      }
    </div>
  </div>
